/* eslint-disable max-len */
/** Definition can be found at https://stash/projects/SOA/repos/event-java/browse/event-domain-entities/src/main/java/com/cvent/shared/RegistrationFieldPageType.java */
/* eslint-enable max-len */

export const Registration = 1;
export const DeclineRegistration = 2;
export const CancelRegistration = 3;
export const GuestRegistration = 4;
export const EventWaitlist = 5;
export const RegistrationPendingApproval = 7;
export const RegistrationApprovalDenied = 8;
export const Archived = 9;
export const PostRegistrationPayment = 10;
